export default defineNuxtRouteMiddleware((to) => {
  if (to.path === '/dashboard/active') {
    return navigateTo({ name: 'dashboard' }, { redirectCode: 301, replace: true })
  }

  return undefined
})
